import type { ReactNode } from 'react';
import { REQUIRED_FIELD_MESSAGE } from '@gonfalon/legacy-form-validation/validationUtils';
import { FieldError } from '@gonfalon/legacy-forms/components';
// oxlint-disable-next-line no-restricted-imports
import { Label, RequiredAsterisk } from '@launchpad-ui/core';

import { COMMENT_AREA_ID, CommentArea } from '#components/forms/CommentArea';

import styles from './Comment.module.css';

type CommentProps = {
  optional?: boolean;
  description?: ReactNode;
  onChange(value: string): void;
  onBlur?(): void;
  onFocus?(): void;
  placeholder?: string;
  comment: string;
  className?: string;
  label?: string;
  showAsterix?: boolean;
  isNotValid?: boolean;
  rows?: number;
  validationMsg?: string;
  disabled?: boolean;
};
export const Comment = ({
  className,
  description,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  comment,
  label = COMMENT_LABEL,
  showAsterix,
  optional = false,
  isNotValid = false,
  rows = 3,
  validationMsg,
  disabled,
}: CommentProps) => (
  <div className={styles.container}>
    <Label className={styles.label} htmlFor={COMMENT_AREA_ID} optional={optional} id="comment-label">
      {label}
      {showAsterix && <RequiredAsterisk />}
    </Label>
    <CommentArea
      description={description}
      rows={rows}
      value={comment || ''}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      placeholder={placeholder}
      isInvalid={isNotValid}
      className={className}
      disabled={disabled}
      aria-labelledby="comment-label"
    />
    {isNotValid && <FieldError name={COMMENT_AREA_ID} errorMessage={validationMsg || REQUIRED_FIELD_MESSAGE} />}
  </div>
);

export const COMMENT_LABEL = 'Comment';
